import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  moduleLink: {
    id: 'portal.components.courseNavigation.module.link.text',
    defaultMessage: 'Module',
    description: 'Module link text',
  },
  notesLink: {
    id: 'portal.components.courseNavigation.notes.link.text',
    defaultMessage: 'Notes',
    description: 'Notes link text',
  },
});

export default messages;
